import {put,} from '../utils'

export default host => data =>
  put(`${host}/user/changeLanguage`, data);